import { render } from "./admin-pages.vue?vue&type=template&id=78542ef2"
import script from "./admin-pages.vue?vue&type=script&lang=js"
export * from "./admin-pages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__